import React, { useState } from 'react';

const PrintThermal = () => {
    const [printerConnected, setPrinterConnected] = useState(false);

    const connectPrinter = async () => {
        try {
            // Request the Bluetooth device
            const device = await navigator.bluetooth.requestDevice({
                filters: [{ services: ['0x18F0'] }] // This service is for Bluetooth printers
            });

            // Connect to the device
            const server = await device.gatt.connect();

            // Get the printer service (you may need to adjust the UUID for the correct printer service)
            const service = await server.getPrimaryService('printer_service_uuid');

            // Get the characteristic to send data to the printer
            const characteristic = await service.getCharacteristic('characteristic_uuid');

            // Send data to the printer (ESC/POS command for basic text print)
            const encoder = new TextEncoder();
            const printData = encoder.encode('\nHello, Thermal Printer!\n\n');

            // Write data to the printer
            await characteristic.writeValue(printData);

            setPrinterConnected(true);
            alert('Printer connected and data sent!');
        } catch (error) {
            console.error('Failed to connect to the printer:', error);
            alert('Error connecting to the printer!');
        }
    };

    return (
        <div>
            <h1>Thermal Printer Bluetooth</h1>
            {printerConnected ? (
                <p>Printer Connected!</p>
            ) : (
                <button onClick={connectPrinter}>Connect to Printer</button>
            )}
        </div>
    );
}

export default PrintThermal;
